export default __webpack_public_path__ + "static/media/externalLinkBlack.cb0a691d.svg";